export const ROLES = {
    seller: 'SELL',
    operator: 'OPER',
    color: 'COLO',
    supervisor: 'SUPE',
    admin: 'ADMI',
    accounter: 'ACCO',
    root: 'ROOT',
    viewer: 'INFO',
    viewerSP: 'VIEW',
    validator: 'VALI',
    marcados: 'MARC',
    crudo: 'CRUD',
    tintoreria: 'TINT',
    enrollado: 'ENRO',
    despacho: 'DESP',
    remisionar: 'REMI',
    tejeduria: 'TEJE',
}